import { SHOP_STATE_KEY } from '../action-types';

const selectShop = state => state[SHOP_STATE_KEY] || {};

export default selectShop;
